import { ChatServiceType } from '../services/chat/ChatServiceInterface';

/**
 * Chat service configuration
 * 
 * To switch chat providers:
 * 1. Change the CHAT_PROVIDER environment variable, or
 * 2. Modify the defaultProvider below
 * 
 * Supported providers: 'crisp', 'intercom', 'zendesk', 'custom'
 */

export const CHAT_CONFIG = {
  // Provider selection (can be overridden by environment variable)
  defaultProvider: 'crisp' as ChatServiceType,
  
  // Provider-specific configurations
  providers: {
    crisp: {
      websiteId: import.meta.env.VITE_CRISP_WEBSITE_ID || "53da18b7-e696-4768-a725-b46512a6d1a0", // Restore working ID as fallback
      // Add other Crisp-specific config here
    },
    intercom: {
      appId: import.meta.env.VITE_INTERCOM_APP_ID || "",
      // Add Intercom-specific config here
    },
    zendesk: {
      key: import.meta.env.VITE_ZENDESK_KEY || "",
      // Add Zendesk-specific config here
    },
    custom: {
      // Add custom provider config here
    }
  },
  
  // Feature flags
  features: {
    // Whether to show fallback feedback modal if chat fails to load
    enableFallback: true,
    
    // Whether to hide the default floating chat button
    hideDefaultButton: true,
    
    // Whether to automatically initialize chat on app load
    autoInitialize: true,
  }
};

// Get the active provider (environment variable takes precedence)
export const getActiveProvider = (): ChatServiceType => {
  const envProvider = import.meta.env.VITE_CHAT_PROVIDER as ChatServiceType;
  return envProvider || CHAT_CONFIG.defaultProvider;
};

// Get configuration for the active provider
export const getProviderConfig = (provider?: ChatServiceType): Record<string, any> => {
  const activeProvider = provider || getActiveProvider();
  return CHAT_CONFIG.providers[activeProvider] || {};
};
